// Display formatting shared across views. Numbers use tabular en-US grouping
// ("1,234.50"); dates are shown in the viewer's local time zone.

export function initials(email: string): string {
  const local = (email || '').split('@')[0]
  const parts = local.split(/[._-]+/).filter(Boolean)
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase()
  return local.slice(0, 2).toUpperCase()
}

export function formatNumber(value: number | null | undefined, fraction = 0): string {
  if (value === null || value === undefined || !isFinite(value)) return '—'
  return value.toLocaleString('en-US', { minimumFractionDigits: fraction, maximumFractionDigits: fraction })
}

export function formatPercent(ratio: number | null | undefined, fraction = 1): string {
  if (ratio === null || ratio === undefined || !isFinite(ratio)) return '—'
  return formatNumber(ratio * 100, fraction) + '%'
}

// "Sep 28, 06:17"
export function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString('en-US', {
    month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false,
  })
}

// "Sep 28, 06:17:05"
export function formatDateTimeSec(iso: string): string {
  return new Date(iso).toLocaleString('en-US', {
    month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
  })
}

// "Mar 12, 2025"
export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })
}

// "14:02:11"
export function formatTime(iso: string): string {
  return new Date(iso).toLocaleTimeString('en-US', {
    hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
  })
}

// "41s", "9m 03s", "2h 00m"
export function formatDuration(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000))
  const h = Math.floor(total / 3600)
  const m = Math.floor((total % 3600) / 60)
  const s = total % 60
  const pad = (n: number) => String(n).padStart(2, '0')
  if (h > 0) return `${h}h ${pad(m)}m`
  if (m > 0) return `${m}m ${pad(s)}s`
  return `${s}s`
}
